import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = {
  class: "select"
};
var _hoisted_2 = ["onClick"];
import { reactive, watchEffect } from 'vue';
// options 是数据源列表 labelkey是显示的字段key valuekey是传给后端需要的字段key multiple是看是否多选或单选 selectList是父组件传递过来的选中的人员列表

export default {
  __name: 'selectRemote',
  props: ['options', 'labelkey', 'valuekey', 'placeholder'],
  emits: ["loadMore", "getchecked", "initList"],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var props = __props;
    var emit = __emit;
    var data = reactive({
      key_word: '',
      showSelect: false
    });
    var handleScroll = e => {
      var scrollTop = e.target.scrollTop;
      var scrollHeight = e.target.scrollHeight;
      var offsetHeight = Math.ceil(e.target.getBoundingClientRect().height);
      var currentHeight = scrollTop + offsetHeight;
      if (currentHeight >= scrollHeight) {
        console.log("说明触底了需告知父组件将page+1 获取数据");
        emit('loadMore', true);
      }
    };
    // 当关键词发生变化时 告知父组件需要关键词搜索了
    watchEffect(() => {
      if (data.key_word || !data.key_word) {
        emit("initList", data.key_word);
      }
      if (!data.key_word || data.key_word == '' | data.key_word == undefined) {
        data.showSelect = false;
      }
    });

    // 选中事件
    var handle_checked = (v, i) => {
      data.key_word = v[props.labelkey];
      emit("getchecked", v);
      data.showSelect = false;
    };
    return (_ctx, _cache) => {
      var _component_el_input = _resolveComponent("el-input");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_input, {
        clearable: "",
        placeholder: props.placeholder,
        onInput: _cache[2] || (_cache[2] = $event => data.showSelect = true),
        style: {
          "width": "100%"
        },
        modelValue: data.key_word,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => data.key_word = $event)
      }, {
        append: _withCtx(() => [!data.showSelect ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = $event => data.showSelect = true),
          class: "iconfont icon-jiantouxia"
        })) : (_openBlock(), _createElementBlock("span", {
          key: 1,
          onClick: _cache[1] || (_cache[1] = $event => data.showSelect = false),
          class: "iconfont icon-jiantoushang"
        }))]),
        _: 1
      }, 8, ["placeholder", "modelValue"]), data.showSelect ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "select_wrap",
        onScroll: handleScroll
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.options, (v, i) => {
        return _openBlock(), _createElementBlock("p", {
          class: _normalizeClass({
            'checked': v.checked,
            'txt': true
          }),
          key: v[props.valuekey],
          onClick: $event => handle_checked(v, i)
        }, _toDisplayString(v[props.labelkey]), 11, _hoisted_2);
      }), 128))], 32)) : _createCommentVNode("", true)]);
    };
  }
};